// from: https://dev.to/polyov_dev/data-validation-in-typescript-using-the-either-pattern-4omk

export interface Left<A> {
  value: A;
  tag: 'left';
}

export interface Right<B> {
  value: B;
  tag: 'right';
}

export type Either<A, B> = Left<A> | Right<B>;

export function isLeft<A>(val: any): val is Left<A> {
  if ((val as Left<A>).tag === 'left') return true;
  return false;
}

export function isRight<B>(val: any): val is Right<B> {
  if ((val as Right<B>).tag === 'right') return true;
  return false;
}

export function left<A>(val: A): Left<A> {
  return { value: val, tag: 'left' };
}

export function right<B>(val: B): Right<B> {
  return { value: val, tag: 'right' };
}
